import PropTypes from 'prop-types';
import Posts from '@/domain/Blog/Posts';
import client from '@/api/client';
import { categoryQuery, categorySlugsQuery } from '@/api/queries';

export async function getStaticProps({ params }) {
  const { data } = await client().query({
    query: categoryQuery,
    variables: {
      id: params.category,
    },
  });

  return {
    props: {
      posts: data?.category?.posts?.nodes || [],
      categories: data?.categories?.nodes || [],
      currentCategory: params.category,
    },
  };
}

export async function getStaticPaths() {
  const { data } = await client().query({ query: categorySlugsQuery });

  const paths = data?.categories?.nodes?.map(({ slug }) => {
    return {
      params: {
        category: slug,
      },
    };
  });

  return {
    paths,
    fallback: false,
  };
}

const defaultProps = {
  posts: [],
  categories: [],
};

const propTypes = {
  posts: PropTypes.arrayOf(PropTypes.object),
  categories: PropTypes.arrayOf(PropTypes.object),
  currentCategory: PropTypes.string.isRequired,
};

export default function Category({ posts, categories, currentCategory }) {
  return (
    <Posts
      posts={posts}
      categories={categories}
      currentCategory={currentCategory}
    />
  );
}

Category.defaultProps = defaultProps;
Category.propTypes = propTypes;
